/**
 * Shapeway's Center Full layout for noty.
 */

module.exports = function($) {

  $.noty.layouts.swCenterFull = {
    name: 'swCenterFull',
    options: {
      type: 'full'
    },
    container: {
      object: '<ul id="noty_swCenterFull_layout_container" />',
      selector: 'ul#noty_swCenterFull_layout_container',
      style: function () {
        $(this).css({
          left: ($(window).width() - $(this).outerWidth(false)) / 2 + 'px'
        });
      }
    },
    parent: {
      object: '<li />',
      selector: 'li',
      css: {}
    },
    css: {
      display: 'none'
    },
    animation: {
      open: 'animated fadeIn', // Animate.css class names
      close: 'animated fadeOut' // Animate.css class names
    }
  };

};
